module.exports = __webpack_public_path__ + "static/media/rrandall-min.712c8979.png";